import * as React from 'react'
import { Descriptions, Form, Input } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'
import { Organization, useOrganization } from '@library/react-toolkit'
import { useMode } from './queries'
import ShowCompanyInfo from './ShowCompanyInfo'

type Props = {
  value?: {
    name?: string
    email?: string
  }
  onChange?: (_?: { name?: string; email?: string }) => void
}

export type OrgWithCr = Organization & { crNumber: string }

const CompanyInfo = ({ value, onChange }: Props) => {
  const organization = useOrganization()
  const mode = useMode()
  const intl = useIntl()
  const companyData = {
    name: mode === 'organization' ? organization?.name ?? '' : '',
    displayName: organization?.displayName ?? '',
    crNumber: (organization as any as OrgWithCr | undefined)?.crNumber ?? '',
    address: 'no address field',
  }

  React.useEffect(() => {
    onChange?.({
      name: companyData.name,
      email: companyData.address,
    })
  }, [])

  return mode === 'organization' ? (
    <ShowCompanyInfo name={companyData.name} />
  ) : (
    <Form<{ name: string; email: string }>
      initialValues={value}
      onValuesChange={(_, v) => onChange?.({ name: v.name, email: v.email })}
    >
      <Descriptions column={1}>
        <Descriptions.Item label={<FormattedMessage id="companyName" />}>
          <Form.Item
            noStyle
            name="name"
            rules={[
              {
                pattern: new RegExp(/^[\w]+$/),
                message: <FormattedMessage id="onlyAlphanumeric" />,
              },
              {
                required: true,
              },
            ]}
          >
            <Input
              placeholder={intl.formatMessage({
                id: 'supplierName',
              })}
            />
          </Form.Item>
        </Descriptions.Item>
        <Descriptions.Item label={<FormattedMessage id="email" />}>
          <Form.Item
            noStyle
            name="email"
            rules={[{ required: true }, { type: 'email' }]}
          >
            <Input
              placeholder={intl.formatMessage({
                id: 'supplierEmail',
              })}
            />
          </Form.Item>
        </Descriptions.Item>
      </Descriptions>
    </Form>
  )
}

export default CompanyInfo
